import { render, staticRenderFns } from "./TourAndPushNotificationPopup.vue?vue&type=template&id=ffe3afa0&scoped=true"
import script from "./TourAndPushNotificationPopup.vue?vue&type=script&lang=js"
export * from "./TourAndPushNotificationPopup.vue?vue&type=script&lang=js"
import style0 from "./TourAndPushNotificationPopup.vue?vue&type=style&index=0&id=ffe3afa0&prod&scoped=true&lang=css"
import style1 from "./TourAndPushNotificationPopup.vue?vue&type=style&index=1&id=ffe3afa0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe3afa0",
  null
  
)

export default component.exports